import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=4bc501c2&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
import style0 from "./Index.vue?vue&type=style&index=0&id=4bc501c2&lang=scss"
import style1 from "./Index.vue?vue&type=style&index=1&id=4bc501c2&lang=sass&scoped=true"
import style2 from "./Index.vue?vue&type=style&index=2&id=4bc501c2&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc501c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3875257498/src/codestar-connections.ap-northeast-1.amazonaws.com/git-http/364953906322/ap-northeast-1/84d36ee7-16b8-4e80-bff0-7e6a249efe8b/OwlTing/owlnest_booking_engine/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bc501c2')) {
      api.createRecord('4bc501c2', component.options)
    } else {
      api.reload('4bc501c2', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=4bc501c2&scoped=true", function () {
      api.rerender('4bc501c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Payment/Index.vue"
export default component.exports